import { createContext, useContext } from 'react';

export const UrqlResetContext = createContext<() => void>(() => {});

export const useResetUrqlClient = () => useContext(UrqlResetContext);
